module.exports = __webpack_public_path__ + "static/media/wasted.6fca925c.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/misc/src/wasted.png
// module id = 192
// module chunks = 0